import api from "./apiService";

export const getBodyTypes = () => api().get(`/bodyTypeMaster/`).then(response => response);

const services = {
    getBodyTypes
}


export default services;